import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class SolutionMasterQueryService {

  public isSaved: any;
  public CREATE_REPORT_SOLUTION_MASTER: any;
  public GET_CLIENT_REPORT_BASED_ON_ORDERID: any;
  private UPDATE_REPORT_SOLUTION_MASTER: any;

  constructor(public apollo: Apollo) {

    this.isSaved = gql` 
      query checkAlreadySaved($insReportId:String!){
        allReportSolutionMasters(condition:{insReportId:$insReportId}) {
              edges {
                  node {                  
                      insReportId                                                 
                      }
              }
          }
      }
      `;

    // Mutation - Create report  solution
    this.CREATE_REPORT_SOLUTION_MASTER = gql` 
       mutation CREATE_REPORT_SOLUTION_MASTER($input: CreateReportSolutionMasterInput!) {
            createReportSolutionMaster(input: $input) {
                reportSolutionMaster{   
                    insReportId         
                }
           }
       }
       `;

    // Mutation - Update report solution
    this.UPDATE_REPORT_SOLUTION_MASTER = gql` 
      mutation UPDATE_REPORT_SOLUTION_MASTER($input:UpdateReportSolutionMasterByIdInput!){
        updateReportSolutionMasterById(input:$input){
            reportSolutionMaster{
              insReportId
            }
        }
      }
    `;

    // Get client reports from report master file
    this.GET_CLIENT_REPORT_BASED_ON_ORDERID =
      gql`     
            query getReportSolutionMasters($insReportId:String!){                           
              allReportSolutionMasters(condition:{insReportId:$insReportId,},orderBy:REVIEW_ID_ASC) {
      
                  nodes {
                    reviewedBy
                    createdAt
                    insReportId
                    reviewId
                    acceptStatus
                    allocated
                    orderId
                    expectedDate
                    buyerProperty
                    id
                    reportReviewDetailByReviewId {
                      categoryId
                      subCategoryId
                      createdAt
                      modifiedAt
                      totalCost
                      labourCost
                      description
                      materialCost
                      resourceLink
                      categoryName
                      subCategoryName
                      orderId
                      solution
                      imagePath
                      solCategory
                      solSubCategory
                      insReportId
                    }
                  }
                
              } 
          }
        `;
  }

  // Check this report already saved or not 
  checkReport(): any {
    return this.apollo
      .watchQuery({
        query: this.isSaved
        ,
        variables:
        {
          'insReportId': window.localStorage.getItem('reportId').trim(),
        },
        fetchPolicy: 'network-only'
      });
  }

  // Insert report details
  insertReport(report, expectedDate, buyerProperty): any {
    return this.apollo.mutate({
      mutation: this.CREATE_REPORT_SOLUTION_MASTER,
      variables: {
        'input': {
          'reportSolutionMaster': {
            'createdAt': new Date(),
            'insReportId': report.insReportId,
            'reviewId': report.reviewId,
            'acceptStatus': report.accept,
            'allocated': false, // check if needed
            'orderId': report.orderId,
            'expectedDate': expectedDate,
            'buyerProperty': buyerProperty
          }
        },

      }
    });
  }

  // Insert report details
  updateReport(report: any): any {
    return this.apollo.mutate({
      mutation: this.UPDATE_REPORT_SOLUTION_MASTER,
      variables: {
        'input': {
          "reportSolutionMasterPatch": {
            "acceptStatus": report.accept,
            'createdAt': new Date(),
          },
          "id": report.id
        },

      }
    });
  }

  GET_ACCEPTED_REPORTS(): any {
    return this.apollo
      .watchQuery({
        query: this.GET_CLIENT_REPORT_BASED_ON_ORDERID
        ,
        variables:
        {
          'insReportId': window.localStorage.getItem('reportId').trim(),
        },
        fetchPolicy: 'network-only'
      });
  }

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/gql-query-mutation/report-solution-master.service..ts